import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';
import { ITutorRating } from '.';

export type TCreateTutorRating = {
  courseId: string;
  rating: number;
  feedback: string;
};

const apiDataProvider = new APIDataProvider();

export const getTutorRatingByCourse = createAsyncThunk(
  '/tutor-ratings/get-by-course',
  async (courseId: string) => {
    const response = await apiDataProvider.get<
      TApiResponse<ITutorRating | null>
    >(`${ApiPaths.tutorRatings}?courseId=${courseId}`);

    return response.data;
  }
);

export const createTutorRating = createAsyncThunk(
  '/tutor-ratings/create',
  async (data: TCreateTutorRating) => {
    const response = await apiDataProvider.post<TApiResponse<ITutorRating>>(
      ApiPaths.tutorRatings,
      data
    );

    return response.data;
  }
);
